/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：810
 */

module.exports = {
  iconWrapper: "style_iconWrapper__qJeOA",
  iconButton: "style_iconButton__1YhDL",
  editIcon: "style_editIcon__1lA7a",
  editStyleIcon: "style_editStyleIcon__3S1D6"
}
